// import React from 'react'
import { format } from 'date-fns';

const DateAndTime = () => {
    const currentDate = new Date();
    const formattedDateTime = format(currentDate, 'yyyy-MM-dd HH:mm:ss');
    return formattedDateTime
}

export { DateAndTime }